let AllocationTypes = {
  SGL: {nameProperty: 'allocationTypeSGL'},
  DBL: {nameProperty: 'allocationTypeDBL'},
  TPL: {nameProperty: 'allocationTypeTPL'},
  QPL: {nameProperty: 'allocationTypeQPL'}
};

export default AllocationTypes;



// WEBPACK FOOTER //
// ./src/enums/AllocationTypes.js